const API_URL = process.env.REACT_APP_API_URL || 'https://still-boat-aa52.mack-joshuaj.workers.dev';

export default class LeaderboardService {
  static async getTop10() {
    try {
      const response = await fetch(`${API_URL}/api/leaderboard/top10`);

      if (!response.ok) {
        throw new Error(`Failed to fetch leaderboard: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      throw error;
    }
  }

  static async getPlayerRank(walletAddress) {
    try {
      const response = await fetch(
        `${API_URL}/api/leaderboard/player-rank?walletAddress=${walletAddress}`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch player rank: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching player rank:', error);
      throw error;
    }
  }

  static formatWalletAddress(address) {
    if (!address || address.length < 9) return address;
    return `${address.substring(0, 5)}...${address.substring(address.length - 3)}`;
  }
}
